export default __webpack_public_path__ + "static/image-60-cf6b226463e86895f0330ba0abb024fe.jpg";